const statesMap = {
  Diagnosis: [
    "Alive",
    "Alive in CR",
    "Alive in Relapse",
    "Death in CR",
    "Death in Relapse",
    "Death without CR"
  ],
  CR: ["Alive in CR", "Alive in Relapse", "Death in CR", "Death in Relapse"]
};

const updatedStatesMap = {
  Diagnosis: [
    "Alive",
    "Alive in CR",
    "Alive in Relapse",
    "Death in CR",
    "Death in Relapse",
    "Death without CR"
  ],
  CR: [
    " ",
    "Alive in CR",
    "Alive in Relapse",
    "Death in CR",
    "Death in Relapse",
    "  "
  ]
};

const colorMap = {
  Alive: "#668c4c",
  "Alive in CR": "#a0c26e",
  "Alive in Relapse": "#dae5af",
  "Death in CR": "#FC8D59",
  "Death in Relapse": "#E34A33",
  "Death without CR": "#B30000dd"
};

const errorMap = {
  Alive: "se1",
  "Alive in CR": "se2",
  "Alive in Relapse": "se3",
  "Death in CR": "se4",
  "Death in Relapse": "se5",
  "Death without CR": "se6"
};

const colorErrorMap = {
  Alive: "#668c4c66",
  "Alive in CR": "#a0c26e66",
  "Alive in Relapse": "#dae5af66",
  "Death in CR": "#FC8D5966",
  "Death in Relapse": "#E34A3366",
  "Death without CR": "#B3000066"
};

// set the dimensions and margins of the graph
const margin = { top: 40, right: 60, bottom: 60, left: 60 };
const width = 500 - margin.left - margin.right;
const height = 450 - margin.top - margin.bottom;

const curvesWidth = width;
const barsWidth = width / 2;
const barHeight = 40;

export default {
  data() {
    return {
      showCIErrors: true
    };
  },
  watch: {
    showCIErrors() {
      this.showOrHideErrors();
    }
  },
  methods: {
    mount() {
      this.plots.forEach(plot => this.createCurvePlot(plot));
    },

    showOrHideErrors() {
      this.$d3
        .selectAll(`.se-layer`)
        .transition()
        .duration(300)
        .attr("opacity", this.showCIErrors ? 1 : 0);

      this.$d3
        .selectAll(`.sediment-errors`)
        .transition()
        .duration(300)
        .attr("opacity", this.showCIErrors ? 1 : 0);
    },

    updatePlots() {
      if (this.d3.selectAll(`${this.selector} svg`).empty()) {
        this.avgPlots.forEach(plot => this.createCurvePlot(plot));
      }
      if (this.d3.selectAll("#patient-chart svg").empty()) {
        this.thisPatientPlots.forEach(plot => this.createCurvePlot(plot));
      }
      this.updateCurvePlots(this.avgPlots);
      this.updateCurvePlots(this.plots);
    },

    renderPlots() {
      if (this.d3.selectAll(`${this.selector} svg`).empty()) {
        this.plots.forEach(plot => this.createCurvePlot(plot));
      } else {
        this.updateCurvePlots(this.plots);
      }
    },

    createCurvePlot(plot) {
      const { data, type, xlabel } = plot;
      const selector = this.selectorsMap[type];

      // Validate data is not empty
      if (!data || !Object.keys(data).length) return;

      // append the svg object to the body of the page
      const chartDiv = this.d3.select(selector);

      const curvesSvg = chartDiv
        .append("svg")
        .attr("width", curvesWidth + margin.left)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("class", "curves-plot")
        .attr("transform", `translate(${margin.left}, ${margin.top})`);

      // Add X axis
      const maxYears = 5;
      const curvesX = this.d3
        .scaleLinear()
        .domain([0, maxYears + 0.05])
        .range([0, curvesWidth]);

      curvesSvg
        .append("g")
        .attr("class", "curves-axis")
        .attr("transform", `translate(0, ${height})`)
        .call(this.d3.axisBottom(curvesX).ticks(5));

      // Add Y axis
      const curvesY = this.d3
        .scaleLinear()
        .domain([0, 1])
        .range([height, 0]);

      this.curvesY = curvesY;

      curvesSvg
        .append("g")
        .attr("class", "curves-axis")
        .call(this.d3.axisLeft(curvesY));

      // text label for the x axis
      curvesSvg
        .append("text")
        .attr(
          "transform",
          `translate(${curvesWidth / 2}, ${height + margin.top})`
        )
        .attr("class", "x-axis-label")
        .style("text-anchor", "middle")
        .text(`Time from ${xlabel} (Years)`);

      // text label for the y axis
      curvesSvg
        .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", -margin.left)
        .attr("x", -height / 2)
        .attr("dy", "1em")
        .style("text-anchor", "middle")
        .text("Probability")
        .attr("font-family", "sans-serif");

      // Stack the data
      const states = statesMap[xlabel];
      const stackedData = this.d3.stack().keys(states)(data);

      // Show the areas
      const area = this.d3
        .area()
        .x(d => curvesX(d.data.time))
        .y0(d => curvesY(d[0]))
        .y1(d => curvesY(d[1]) || 0)
        .curve(this.d3.curveBasis);

      curvesSvg
        .selectAll(".layer")
        .data(stackedData)
        .enter()
        .append("g")
        .attr("class", "layer")
        .append("path")
        .attr("class", "area")
        .style("fill", d => colorMap[d.key])
        .attr("d", area);

      // Show the errors
      const errors = this.d3
        .area()
        .x(d => curvesX(d.data.time))
        .y0(this.updateLowerSedimentErrorCurve)
        .y1(this.updateUpperSedimentErrorCurve)
        .curve(this.d3.curveBasis);

      curvesSvg
        .selectAll(".se-layer")
        .data(stackedData)
        .enter()
        .append("g")
        .attr("class", "se-layer")
        .style("pointer-events", "none")
        .append("path")
        .attr("class", "se-area")
        .style("fill", "#ffffff66")
        .style("stroke", "black")
        .style("stroke-dasharray", 4)
        .style("stroke-width", 1)
        .attr("d", errors);

      // Add line between alive and death
      const lifeCurve = this.d3
        .line()
        .x(d => curvesX(d.data.time))
        .y(d => curvesY(d[0]))
        .curve(this.d3.curveBasis);

      curvesSvg
        .append("path")
        .data([stackedData[3]])
        .attr("class", "line")
        .attr("d", lifeCurve)
        .attr("fill", "none")
        .attr("stroke", "black")
        .attr("stroke-width", 2.5)
        .style("pointer-events", "none");

      // Show the labels
      curvesSvg
        .selectAll("state-plot-labels")
        .data(states)
        .enter()
        .append("text")
        .attr("text-anchor", "end")
        .attr("font-family", "sans-serif")
        .attr("y", (_, i) => {
          const pN = Math.floor(0.98 * stackedData[i].length);
          const lastStateTimePoint = stackedData[i][pN];
          return (
            curvesY((lastStateTimePoint[0] + lastStateTimePoint[1]) / 2) - 5
          );
        })
        .attr("x", () => curvesWidth - 20)
        .text(d => d)
        .attr("class", "state-plot-label")
        .style("pointer-events", "none");

      // Create the black vertical line to follow mouse
      curvesSvg
        .append("path")
        .attr("class", "vertical-hover-line")
        .style("stroke", "black")
        .style("stroke-width", 1)
        .style("opacity", 1)
        .style("pointer-events", "none")
        .style("stroke-dasharray", "8 4");

      curvesSvg
        .append("path")
        .attr("class", "vertical-line")
        .style("stroke", "black")
        .style("stroke-width", 1)
        .style("opacity", 1)
        .style("pointer-events", "none")
        .attr("d", `M${curvesX(1)}, ${height} ${curvesX(1)},0`);

      // Hover Events to Change Opacities
      curvesSvg
        .selectAll(".layer")
        .on("mouseenter", (_, i, dim) => {
          const areaOpacity = this.showCIErrors ? 0 : 0.2;
          const barOpacity = 0.4;

          // Show Areas Opacity
          curvesSvg
            .selectAll(".layer")
            .transition()
            .duration(300)
            .attr("opacity", (_, j) => (j === i ? 1 : areaOpacity));

          if (this.showCIErrors) {
            curvesSvg
              .selectAll(".se-layer")
              .transition()
              .duration(300)
              .attr("opacity", (_, j) => (j === i ? 1 : areaOpacity));

            curvesSvg
              .selectAll(".se-layer .se-area")
              .transition()
              .duration(300)
              .style("fill", (d, j) =>
                j === i ? colorMap[d.key] + "99" : "#ffffff66"
              );

            this.d3
              .selectAll(`${selector} .sediment-errors`)
              .transition()
              .duration(300)
              .attr("opacity", (_, j) => (j === i ? 1 : barOpacity));
          }

          curvesSvg
            .selectAll(".state-plot-label")
            .transition()
            .duration(300)
            .attr("opacity", (_, j) => (j === i ? 1 : areaOpacity));

          // Show areas borders
          this.d3
            .select(dim[i])
            .classed("hover", true)
            .attr("stroke", "black")
            .attr("stroke-width", 1);

          // Modify bars opacity
          this.d3
            .selectAll(`${selector} .bar rect`)
            .transition()
            .duration(300)
            .attr("opacity", (_, j) => (j === i ? 1 : barOpacity));

          this.d3
            .selectAll(`${selector} .bar-labels`)
            .transition()
            .duration(300)
            .attr("opacity", (_, j) => (j === i ? 1 : barOpacity));

          this.d3
            .selectAll(`${selector} .bars-svg .tick`)
            .transition()
            .duration(300)
            .attr("opacity", (_, j) => (j === i ? 1 : barOpacity));

          // Show vertical lines
          this.d3
            .selectAll(`${selector} .vertical-hover-line`)
            .style("opacity", 1);
        })
        .on("mousemove", (_, i, dim) => {
          // Show Vertical Line
          const mouseX = this.d3.mouse(dim[i])[0];
          this.d3
            .selectAll(`${selector} .vertical-hover-line`)
            .attr("d", `M${mouseX},${height} ${mouseX},0`);
        })
        .on("mouseout", (_, i, dim) => {
          // Show Areas Normal Opacity
          curvesSvg
            .selectAll(".layer")
            .transition()
            .duration(300)
            .attr("opacity", "1");

          if (this.showCIErrors) {
            curvesSvg
              .selectAll(".se-layer")
              .transition()
              .duration(300)
              .attr("opacity", 1);

            curvesSvg
              .selectAll(".se-layer .se-area")
              .transition()
              .duration(300)
              .style("fill", "#ffffff66");

            this.d3
              .selectAll(`${selector} .sediment-errors`)
              .transition()
              .duration(300)
              .attr("opacity", 1);
          }

          curvesSvg
            .selectAll(".state-plot-label")
            .transition()
            .duration(300)
            .attr("opacity", 1);

          this.d3
            .selectAll(`${selector} .bar rect`)
            .transition()
            .duration(300)
            .attr("opacity", 1);

          this.d3
            .selectAll(`${selector} .bar-labels`)
            .transition()
            .duration(300)
            .attr("opacity", 1);

          this.d3
            .selectAll(`${selector} .bars-svg .tick`)
            .transition()
            .duration(300)
            .attr("opacity", 1);

          this.d3
            .selectAll(`${selector} .vertical-hover-line`)
            .style("opacity", 0);

          this.d3
            .select(dim[i])
            .classed("hover", false)
            .attr("stroke-width", "0px");
        });

      // Dispatch
      const dispatch = this.d3.dispatch("timechanged");

      curvesSvg.on("click", (_, i, dim) => {
        // Show Vertical Line
        const mouseX = this.d3.mouse(dim[i])[0];
        this.d3
          .selectAll(".vertical-line")
          .attr("d", `M${mouseX},${height} ${mouseX},0`);

        const mouse = this.d3.mouse(dim[i]);
        dispatch.call("timechanged", this, curvesX.invert(mouse[0]));
      });

      dispatch.on("timechanged.bar", this.updateBarPlots);

      // Initialize bar plots in 1 year
      this.createBarPlot(chartDiv, plot);

      // Store created elements in component
      this.elements[type] = {
        curvesSvg,
        curvesX,
        curvesY
      };
    },

    updateLowerSedimentErrorCurve(d, i, s) {
      const prob = (d[1] || 0) * 100;
      const se = d.data[errorMap[s.key]] * 100;
      const lowerBound = this.confidenceInterval(prob, se, "lower");
      return this.curvesY(lowerBound / 100);
    },

    updateUpperSedimentErrorCurve(d, i, s) {
      const prob = (d[1] || 0) * 100;
      const se = d.data[errorMap[s.key]] * 100;
      const upperBound = this.confidenceInterval(prob, se, "upper");
      return this.curvesY(upperBound / 100);
    },

    updateCurvePlots(plots) {
      plots.forEach(plot => {
        const { data, type, xlabel } = plot;
        const { curvesSvg, curvesX, curvesY } = this.elements[type];
        const selector = this.selectorsMap[type];

        if (!curvesSvg) return;

        // Stack the data
        const states = statesMap[xlabel];
        const updateStates = updatedStatesMap[xlabel];
        const stackedData = this.d3.stack().keys(updateStates)(data);

        // Show the areas
        const area = this.d3
          .area()
          .x(d => curvesX(d.data.time))
          .y0(d => curvesY(d[0]))
          .y1(d => curvesY(d[1]) || 0)
          .curve(this.d3.curveBasis);

        curvesSvg
          .selectAll(`${selector} .layer .area`)
          .data(stackedData)
          .transition()
          .duration(300)
          .style("fill", d => colorMap[d.key])
          .attr("d", area);

        // Show the errors
        const errors = this.d3
          .area()
          .x(d => curvesX(d.data.time))
          .y0(this.updateLowerSedimentErrorCurve)
          .y1(this.updateUpperSedimentErrorCurve)
          .curve(this.d3.curveBasis);

        curvesSvg
          .selectAll(`${selector} .se-layer .se-area`)
          .data(stackedData)
          .transition()
          .duration(300)
          .style("fill", "#fffff66")
          .attr("d", errors);

        // Add line between alive and death
        const lifeCurve = this.d3
          .line()
          .x(d => curvesX(d.data.time))
          .y(d => curvesY(d[0]))
          .curve(this.d3.curveBasis);

        curvesSvg
          .selectAll(`${selector} .line`)
          .data(() => [stackedData[3]])
          .transition()
          .duration(300)
          .attr("fill", "none")
          .attr("stroke", "black")
          .attr("d", lifeCurve);

        // Update the labels
        curvesSvg
          .selectAll(`${selector} .state-plot-label`)
          .data(() => (xlabel === "Diagnosis" ? states : updateStates))
          .transition()
          .duration(300)
          .attr("y", (d, i) => {
            const pN = Math.floor(0.98 * stackedData[i].length);
            const lastStateTimePoint = stackedData[i][pN];
            return (d == " ") | (d == "  ")
              ? 0
              : curvesY((lastStateTimePoint[0] + lastStateTimePoint[1]) / 2);
          })
          .attr("x", () => curvesWidth - 20)
          .text(d => d);
      });
    },

    createBarPlot(chartDiv, plot) {
      const states = statesMap[plot.xlabel];
      const barsX = this.d3.scaleLinear().range([0, barsWidth]);
      const barsY = this.d3
        .scaleBand()
        .range([height, 0])
        .padding(10);

      const barsSvg = chartDiv
        .append("svg")
        .attr("class", "bars-svg")
        .attr("width", barsWidth + 3 * margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${3 * margin.left}, ${margin.top})`);

      barsY.domain(states);
      barsX.domain([0, 100]);
      barsSvg
        .selectAll(".bar")
        .data(states)
        .enter()
        .append("g")
        .attr("class", "bar")
        .append("rect")
        .style("fill", d => colorMap[d])
        .attr("y", d => barsY(d) - 30)
        .attr("height", 60)
        .attr("x", () => barsX(0))
        .attr("width", () => barsWidth - barsX(0));

      const verticalAdjust = 0;
      barsSvg
        .selectAll(".bar-labels")
        .data(states)
        .enter()
        .append("g")
        .attr("class", "bar-labels")
        .append("text")
        .attr("y", d => barsY(d) - verticalAdjust)
        .attr("x", () => barsX(0))
        .attr("text-anchor", "start")
        .attr("font-size", "15px")
        .attr("font-family", "sans-serif")
        .attr("alignment-baseline", "central");

      // Add title
      barsSvg
        .append("g")
        .attr("class", "bar-title")
        .append("text")
        .attr("x", barsWidth / 2)
        .attr("y", -margin.top / 2)
        .attr("text-anchor", "middle");

      barsSvg
        .append("g")
        .attr("class", "barYlabel")
        .style("transform", "translate(-0.5px, 0px)")
        .call(
          this.d3
            .axisLeft(barsY)
            .tickSize(0)
            .tickPadding(5)
        )
        .selectAll("text")
        .style("text-anchor", "end")
        .style("font-size", "14px");

      // Text label for the x axis
      barsSvg
        .append("text")
        .attr(
          "transform",
          `translate(${barsWidth / 2}, ${height + margin.top + 20})`
        )
        .style("text-anchor", "middle")
        .attr("font-family", "sans-serif");

      // text label for the y axis
      barsSvg
        .append("text")
        .attr("y", -margin.left)
        .attr("x", -height / 2)
        .attr("dy", "1em")
        .style("text-anchor", "start")
        .text("Probability (in %)")
        .attr("font-family", "sans-serif");

      // Error Bars
      const errorTickHeight = 6;
      const errorBars = barsSvg
        .selectAll(".sediment-errors")
        .data(states)
        .enter()
        .append("g")
        .attr("class", "sediment-errors");

      // main error bar
      errorBars
        .append("line")
        .attr("class", "error-bar")
        .attr("y1", d => barsY(d) + verticalAdjust)
        .attr("y2", d => barsY(d) + verticalAdjust)
        .attr("x1", () => barsX(0))
        .attr("x2", () => barsX(0))
        .attr("stroke", "black")
        .attr("stroke-width", 1)
        .attr("fill", "none");

      // error bar left tick
      errorBars
        .append("line")
        .attr("class", "error-bar-left")
        .attr("y1", d => barsY(d) - errorTickHeight + verticalAdjust)
        .attr("y2", d => barsY(d) + errorTickHeight + verticalAdjust)
        .attr("x1", () => barsX(0))
        .attr("x2", () => barsX(0))
        .attr("stroke", "black")
        .attr("stroke-width", 1)
        .attr("fill", "none");

      // error bar right tick
      errorBars
        .append("line")
        .attr("class", "error-bar-right")
        .attr("y1", d => barsY(d) - errorTickHeight + verticalAdjust)
        .attr("y2", d => barsY(d) + errorTickHeight + verticalAdjust)
        .attr("x1", () => barsX(0))
        .attr("x2", () => barsX(0))
        .attr("stroke", "black")
        .attr("stroke-width", 1)
        .attr("fill", "none");

      // Initialize in 1st timepoint
      this.updateBarPlots(1);
    },

    /*
      Crit for 95% Confidence Interval, which corresponds to +/-z for 2.5% and 97.5%.

      qnorm((1 - 0.95) / 2, (lower.tail = FALSE))
      [1] 1.959964
    */
    confidenceInterval(prob, se, bound) {
      if (!prob) return 0; // lines perfectly with Y axis

      const crit = 1.959964;
      const upper = Math.exp(Math.log(prob) + (crit * se) / prob);
      const lower = Math.exp(Math.log(prob) - (crit * se) / prob);

      if (bound === "upper") {
        return upper < 100 ? upper : 100;
      } else if (bound === "lower") {
        return lower > 0 ? lower : 0;
      }
    },

    updateBarPlots(d) {
      // bars scales
      const barsX = this.d3.scaleLinear().range([0, barsWidth]);
      const barsY = this.d3
        .scaleBand()
        .range([height, 0])
        .padding(10);

      this.plots.forEach(plot => {
        // depends on where user clicks, number of states can be different
        const states = updatedStatesMap[plot.xlabel];
        const selector = this.selectorsMap[plot.type];
        barsY.domain(states);

        this.d3
          .selectAll(`${selector} .barYlabel`)
          .call(
            this.d3
              .axisLeft(barsY)
              .tickSize(0)
              .tickPadding(5)
          )
          .selectAll("text")
          .style("text-anchor", "end")
          .style("font-size", "14px");

        // d is a time point; given the time point,
        d = d >= 0 ? d : 0;
        let stateValues = plot.data.filter(row => row.time >= d)[0];
        if (plot.xlabel === "CR") {
          delete stateValues["Alive"];
          delete stateValues["Death without CR"];
        }
        let timeStates = states.map(state => ({
          state,
          value: Math.round(stateValues[state] * 100),
          error: stateValues[errorMap[state]] * 100
        }));
        if (plot.xlabel == "CR") {
          const dummy1 = { state: " ", value: 0, error: 0 };
          const dummy2 = { state: "  ", value: 0, error: 0 };
          timeStates = [
            dummy1,
            timeStates[1],
            timeStates[2],
            timeStates[3],
            timeStates[4],
            dummy2
          ];
        }

        this.d3
          .selectAll(`${selector} .bar rect`)
          .data(timeStates)
          .transition()
          .duration(300)
          .attr("x", () => 0)
          .attr("y", d => barsY(d.state) - barHeight / 2)
          .attr("width", d => barsX(d.value / 100))
          .attr("height", barHeight);

        this.d3
          .selectAll(`${selector} .bar-labels text`)
          .data(timeStates)
          .transition()
          .duration(300)
          // .attr('x', (d) => barsX(d.value / 100) + 10)
          .attr("x", d => {
            const upperSe = this.confidenceInterval(d.value, d.error, "upper");
            return barsX(upperSe / 100) + 5;
          })
          .text(d => {
            if (!(d.state == " " || d.state == "  ")) {
              return `${d.value}%`;
            }
          });

        // Add Error Bars
        this.d3
          .selectAll(`${selector} .sediment-errors line.error-bar`)
          .data(timeStates)
          .transition()
          .duration(300)
          .attr("x1", d =>
            barsX(this.confidenceInterval(d.value, d.error, "upper") / 100)
          )
          .attr("x2", d =>
            barsX(this.confidenceInterval(d.value, d.error, "lower") / 100)
          );

        this.d3
          .selectAll(`${selector} .sediment-errors line.error-bar-left`)
          .data(timeStates)
          .transition()
          .duration(300)
          .attr("x1", d =>
            barsX(this.confidenceInterval(d.value, d.error, "lower") / 100)
          )
          .attr("x2", d =>
            barsX(this.confidenceInterval(d.value, d.error, "lower") / 100)
          );

        this.d3
          .selectAll(`${selector} .sediment-errors line.error-bar-right`)
          .data(timeStates)
          .transition()
          .duration(300)
          .attr("x1", d =>
            barsX(this.confidenceInterval(d.value, d.error, "upper") / 100)
          )
          .attr("x2", d =>
            barsX(this.confidenceInterval(d.value, d.error, "upper") / 100)
          );

        // Update Bar Title
        const year = Math.round((d + Number.EPSILON) * 10) / 10;
        const survivalProbability = timeStates.reduce(
          (total, { state, value }) =>
            state.includes("Alive") ? total + value : total,
          0
        );
        this.d3
          .select(`${selector} .bar-title text`)
          .html(
            `At time ${year} year(s). Survival Prob.
            <tspan class="survival-odds">${survivalProbability}%</tspan>`
          )
          .style("font-size", "18px");

        this.d3.selectAll("text.x-axis-label").text(
          `Time from ${plot.xlabel == "CR" ? "Complete Remission" : plot.xlabel}
            (Years)`
        );
      });
    }
  }
};
